import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../Buttons/Buttons";
import Select from 'react-select';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadQADropdownData, loadReportingToDropdownData, loadTechnicalDropdownData, postAssignComplaintEscalationDatas, postComplaintEscalationDatas, postComplaintEscalationERTDatas } from "../../redux/action";
import * as HeaderAuthentication from '../HeaderAuthentication';
import { ADDED_BY_ID } from "../../Constants";

const UpdateERT = (props) => {
    let dispatch = useDispatch();
    const getComplaintData = props.getComplaintData;
    const complaintId = props.complaintId;

    const [ertData, setErtData] = useState({
        ComplaintID: complaintId,
        TATInDays: null,
        AddedByID: ADDED_BY_ID
    });

    const [errors, setErrors] = useState({}); // Error state to store validation errors

    // Validate form fields
    const validateForm = () => {
        const newErrors = {};
        // if (!assignToData.Priority) newErrors.Priority = "Priority is required.";
        // if (!assignToData.AssignedToUserID) newErrors.AssignedToUserID = "Assigned To is required.";
        if (!ertData.TATInDays) newErrors.TATInDays = "ERT (In Days) is required.";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handle form submission (add complaint escalation data)
    const addComplaintEscalationErtData = (e) => {
        e.preventDefault();
        if (validateForm()) {
            let requestOption = {
                method: "POST",
                mode: "cors",
                headers: HeaderAuthentication.postExcomatixAuth,
                body: JSON.stringify({
                    ...ertData,
                    TATInDays: parseInt(ertData.TATInDays, 10) // ensure it's an integer
                }),
            };
            dispatch(postComplaintEscalationERTDatas(requestOption, props.handleCloseERTModal, getComplaintData));
            // console.log(ertData, 'ertData')
        }
    }

    // Clear error for specific field
    const clearError = (field) => {
        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            delete newErrors[field];
            return newErrors;
        });
    };

    return (
        <Modal show={props.showERTModal} onHide={props.handleCloseERTModal} className='add-role-modal'>
            <Modal.Header closeButton>
                <Modal.Title>Update ERT</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className='customer-form-fields'>
                    <Col>
                        <Row>
                            <Col md={12}>
                                <div>
                                    <label className="p-2">Estimated Resolution Time (In Days) </label>
                                    <Form.Control
                                        type="number"
                                        min="0"  // Prevents negative input
                                        value={ertData.TATInDays || null}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            const parsedValue = value === '' ? '' : parseInt(value, 10);
                                            setErtData(prevData => ({ ...prevData, TATInDays: parsedValue }));
                                            if (errors.TATInDays) clearError("TATInDays");
                                        }}
                                    />
                                    {errors.TATInDays && <small className="text-danger">{errors.TATInDays}</small>}
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseERTModal} />
                <SBSaveUpdateBtn btnName="Submit" onClickEffect={addComplaintEscalationErtData} />
            </Modal.Footer>
        </Modal>
    );
}

export default UpdateERT;
